import { createSelector } from "reselect";

const selectMandatoryCom = (state) => state.mandatoryCom;

export const selectMandatoryComponents = createSelector(
  [selectMandatoryCom],
  (mandatoryCom) => mandatoryCom.mandatoryComponents
);
